<template>
  <div>
    <b-row>
      <b-col cols="3">
        <b-form-group label="Número da Emenda:">
          <b-form-input
            v-model="emenda.emenda"
            placeholder="Número da Emenda"
            :state="validateState('emenda')"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Nome do(a) Parlamentar:">
          <b-form-input
            v-model="emenda.parlamentar"
            placeholder="Nome do(a) parlamentar"
            :state="validateState('parlamentar')"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-form-group label="Valor de repasse:">
      <NumberFormat
        v-model="emenda.repasse"
        placeholder="Valor de repasse"
        :state="validateState('repasse')"
      />
    </b-form-group>

    <hr />

    <h3>Dados Beneficiário</h3>
    <b-row>
      <b-col cols="3">
        <b-form-group label="CNPJ:">
          <Cnpj
            v-model="emenda.cnpj"
            placeholder="CNPJ"
            :state="validateState('cnpj')"
          />
          <b-form-invalid-feedback>
            <span v-if="!$v.emenda.cnpj.cnpj">CNPJ inválido</span>
            <span v-else>CNPJ é obrigatório</span>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Beneficiário:">
          <b-form-input
            v-model="emenda.beneficiario"
            placeholder="Nome"
            :state="validateState('beneficiario')"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-form-group label="Município:">
      <SelectMunicipio v-model="emenda.municipio" />
    </b-form-group>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import SelectMunicipio from "@/modules/municipios/Components/SelectMunicipio";
import NumberFormat from "@/components/Form/NumberFormat.vue";
import Cnpj from "@/components/Form/Cnpj.vue";
import { cnpj } from "cpf-cnpj-validator";

export default {
  mixins: [validationMixin],
  components: { SelectMunicipio, NumberFormat, Cnpj },
  props: {
    value: {},
  },
  data: () => ({
    emenda: {
      emenda: "",
      parlamentar: "",
      repasse: "",
      cnpj: "",
      beneficiario: "",
      municipio: "",
    },
  }),
  validations: {
    emenda: {
      emenda: {
        required,
      },
      parlamentar: {
        required,
      },
      repasse: {
        required,
      },
      cnpj: {
        cnpj: (value) => {
          return !value || cnpj.isValid(value);
        },
      },
      beneficiario: {},
      municipio: {},
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.emenda[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.emenda.$touch();
      return !this.$v.emenda.$anyError;
    },
    save() {
      if (!this.isValid()) {
        this.$notifications.addNotification({
          message: "Os dados do formulário são inválidos",
          type: "danger",
        });

        return null;
      }
      return this.emenda;
    },
  },

  created() {
    if (this.value) {
      this.emenda = JSON.parse(JSON.stringify(this.value));
    }
  },
};
</script>

<style></style>
